/* global ResponsiveBootstrapToolkit */
/* eslint no-unused-vars: 0 indent: 0 */

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-prd-list-page]")) {
        const productListingPage = new ProductListingPage();
        productListingPage.init();
    }

    document.querySelectorAll(".nav-tabs-line a.tab-disabled").forEach(tab => {
        tab.addEventListener("click", function (e) {
            e.stopImmediatePropagation();
        });
    });
});

export default class ProductListingPage {
    constructor() {
        this.productFilterForm = document.getElementById("productFilterForm");
    }

    init() {
        this.bindEvents();
        this.updateFilters();
    }

    bindEvents() {
        document.querySelectorAll("div.tags input[type=checkbox]").forEach(checkbox => {
            checkbox.addEventListener("click", this.updateFilters.bind(this));
        });

        document.querySelectorAll(".reset").forEach(resetButton => {
            resetButton.addEventListener("click", () => {
                document.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                    checkbox.checked = false;
                });
                document.querySelectorAll(".tagDiv, .reset").forEach(element => {
                    element.style.display = "none";
                });
            });
        });

        this.productFilterForm.addEventListener("change", (event) => {
            if (event.target.type === "checkbox" && !this.isMobileView()) {
                this.productFilterForm.submit();
            }
        });
    }

    isMobileView() {
        var viewport = ResponsiveBootstrapToolkit;
        return viewport.is("<=xs");
    }

    getElementDisplayText(element) {
        var displayValue = element.dataset.displayText;
        if (displayValue) return displayValue;
        return element.value;
    }

    updateFilters() {
        var tags = document.getElementById("tags");
        tags.innerHTML = "";
        var checkedTags = document.querySelectorAll("div.tags input:checked");
        if (checkedTags.length > 0) {
            checkedTags.forEach(checkedTag => {
                var tag = document.createElement("div");
                tag.className = "tagDiv delete";
                tag.dataset.value = checkedTag.value;
                tag.setAttribute("filter", checkedTag.closest(".panel").querySelector(".panel-heading").id);
                tag.innerHTML = ` X  ${this.getElementDisplayText(checkedTag)}`;
                tags.appendChild(tag);

                tag.addEventListener("click", () => {
                    var panel = document.querySelector(`.panel-group .panel[id="${tag.getAttribute("filter")}"]`);
                    var checkbox = panel.querySelector(`div.tags input[type=checkbox][value="${tag.dataset.value}"]`);
                    checkbox.click();
                });
            });

            document.querySelectorAll(".reset").forEach(resetButton => {
                resetButton.style.display = "block";
            });
        } else {
            document.querySelectorAll(".reset").forEach(resetButton => {
                resetButton.style.display = "none";
            });
        }
    }
}
